import { createFileRoute, Outlet } from "@tanstack/react-router";
import React from "react";
import { AppSidebar } from "@/components/app-sidebar";
import { CommandPalette } from "@/components/command-palette";
import { DialogManagerProvider } from "@/components/dialog-manager";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { requireUser } from "@/lib/session";

export const Route = createFileRoute("/_app")({
	component: AppLayout,
	beforeLoad: async () => {
		const user = await requireUser();

		return { user };
	},
});

function AppLayout() {
	return (
		<DialogManagerProvider>
			<CommandPalette>
				<SidebarProvider
					style={
						{
							"--sidebar-width": "calc(var(--spacing) * 72)",
							"--header-height": "calc(var(--spacing) * 12)",
						} as React.CSSProperties
					}
				>
					<AppSidebar variant="inset" />
					<SidebarInset>
						<Outlet />
					</SidebarInset>
				</SidebarProvider>
			</CommandPalette>
		</DialogManagerProvider>
	);
}
